import { OptimizelyError } from "./optimizly_error";
export class ErrorReporter {
    constructor(logger, errorNotifier) {
        this.logger = logger;
        this.errorNotifier = errorNotifier;
    }
    report(error, ...params) {
        if (typeof error === 'string') {
            error = new OptimizelyError(error, ...params);
            this.report(error);
            return;
        }
        if (this.errorNotifier) {
            this.errorNotifier.notify(error);
        }
        if (this.logger) {
            this.logger.error(error);
        }
    }
    setLogger(logger) {
        this.logger = logger;
    }
    setErrorNotifier(errorNotifier) {
        this.errorNotifier = errorNotifier;
    }
}
export const __platforms = ['__universal__'];
//# sourceMappingURL=error_reporter.js.map